/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ConstraintResource } from "./ConstraintResource";
export const ConstraintVersionResource = core.serialization
    .object({
    version: core.serialization.number(),
    prompt: core.serialization.string().optional(),
})
    .extend(ConstraintResource);
